// import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "./index.css";
import "./assets/patternLibrary.css";
import "./assets/checkboxes.css";
import "./assets/radio-button.css";
import "./assets/buttons.css";
import "./assets/global-form-styles.css";
import "./assets/phase-banner.css";
import "./assets/summary-block.css";
import "./assets/panel.css";
import "./assets/toggle.css";
// import './assets/supplimentary-page-styles.css'
import "../node_modules/@fortawesome/fontawesome-free/css/all.css";
import App from "./containers/App/App";
import { createRoot } from "react-dom/client";

const root = createRoot(document.getElementById("root"));
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
